import {
  useCallback, useEffect, useRef, useState,
} from 'react';

const useDropdown = (timeout = 100) => {
  const [isOpened, setOpenedRaw] = useState(false);

  const timeoutHandle = useRef<number | undefined>(undefined);
  const debounceHandle = useRef<number | undefined>(undefined);

  useEffect(() => () => {
     window.clearTimeout(timeoutHandle.current);
     window.clearTimeout(debounceHandle.current);
  }, [timeout]);

  const setOpened = useCallback<typeof setOpenedRaw>((state) => {
    if (!debounceHandle.current) {
      setOpenedRaw(state);
      debounceHandle.current = window.setTimeout(() => {
        debounceHandle.current = undefined;
      }, 50);
    }
  }, [setOpenedRaw]);

  const open = useCallback(() => {
    window.clearTimeout(timeoutHandle.current);
    setOpened(true);
  }, [setOpened]);

  const toggle = useCallback(() => {
    window.clearTimeout(timeoutHandle.current);
    setOpened((state) => !state);
  }, [setOpened]);

  const closeNow = useCallback(() => {
    window.clearTimeout(timeoutHandle.current);
    setOpened(false);
  }, [setOpened]);

  const close = useCallback(() => {
    window.clearTimeout(timeoutHandle.current);
    timeoutHandle.current = window.setTimeout(() => setOpened(false), timeout);
  }, [setOpened, timeout]);

  return {
    isOpened,
    open,
    close,
    toggle,
    closeNow,
  };
};

export default useDropdown;
